/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorPlugins } from '../../types/EditorPlugins';
import { getPluginByClassName } from '../getPluginByClassName/getPluginByClassName';
import { hasPluginConflict } from '../hasPluginConflict/hasPluginConflict';

export function findConflictingPlugins( editorPlugins: EditorPlugins, pluginsToSelect: EditorPlugins ): EditorPlugins {
	return editorPlugins
		.map( getPluginByClassName )
		.filter( selectedPlugin => hasPluginConflict( selectedPlugin, pluginsToSelect ) )
		.map( conflictingPlugin => conflictingPlugin.className );
}
